import React from 'react';
import { ProjectDecimalOption } from '@/types';
import { NumberDisplay, NumberDisplayProps } from '@ygtechnologies/bygr-frontend-component-library';

export const getMinimumProjectFractionDigits = (option: ProjectDecimalOption | undefined) => {
    if (option === ProjectDecimalOption.Two) {
        return 2;
    } else {
        return 0;
    }
};

export const getMaximumFractionDigits = (option: ProjectDecimalOption | undefined) => {
    if (option === ProjectDecimalOption.Two) {
        return 2;
    } else {
        return 0;
    }
};

export type CurrencyDisplayProps = NumberDisplayProps & {
    value: number;
    currency: string;
};

const CurrencyDisplayComp: React.FC<CurrencyDisplayProps> = ({ minimumFractionDigits = 0, currency, ...rest }) => {
    return (
        <NumberDisplay numberStyle="currency" currency={currency} minimumFractionDigits={minimumFractionDigits} {...rest} />
    );
};

export const CurrencyDisplay = React.memo(CurrencyDisplayComp);
